import { map } from "lodash"
import { useSelector } from "react-redux"
import moment from "moment"

/**
 * Modifie une phrase en une longueur spécifiée et ajoute des points de suspension si nécessaire.
 * @param {string} str - La phrase à modifier
 * @param {number} length - La longueur maximale de la phrase.
 * @param {number} slice - Le nombre de caractères à découper de la phrase.
 * @returns {string} - Le mot brisé avec des points de suspension si nécessaire.
 */
export const breakWord = (str, length, slice) => {
  if (str && str?.length >= length) return `${str?.slice(0, slice)}...`
  else return str || ""
}

/**
 * Calcule la différence entre deux dates en secondes, minutes, heures et jours.
 * @param {Date} date1 - Le première date.
 * @param {Date} date2 - la seconde date.
 * @returns {Object} - Un objet contenant la différence entre les deux dates en secondes, minutes, heures et jours.
 */
export const dateDiff = (date1, date2) => {
  return moment(date2).diff(moment(date1), "days")
}

export const transformDate = date => {
  if (date && date !== "") {
    const splitTime = date?.includes("T") ? date?.split("T") : date?.split(" ")
    const workDate = splitTime?.[0]?.split("-")

    return `${workDate?.[2]}/${workDate?.[1]}/${workDate?.[0]}`
  }
}

/**
 * Récupérer le nanoid selon le nom d'une source
 * @param {String} sourceCategory
 * @param {String} sourceName
 * @returns le nanoid de la source recherché
 */
export function getSourceNanoid(sourceCategory, sourceName) {
  const dataCatalogueSources = useSelector(state => state.sources.allSources)

  const source = dataCatalogueSources?.find(
    data => data.name === sourceName && data.category === sourceCategory
  )

  const nanoid = source?.nanoid

  return nanoid
}